/* eslint-disable max-statements */
import { addExtraToBasket, createBasket } from '../../api/basket';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { basketOperations, basketTypes } from '../../store/basket';

import { DAS_ADD_EXTRAS_TO_BASKET_FAILED } from '../../constants/errors';
import { createError } from '../../store/errors';
import { messageOperations } from '../../store/messages';
import { reloadBasket } from './helpers';

const { ADD_EXTRAS_TO_BASKET } = basketTypes;
const { sendMessage } = messageOperations;

export const performAddExtrasToBasket = function* performAddExtrasToBasket({
  payload,
}) {
  const {
    addToBasketFailed,
    createBasketSuccess,
    resetBasket,
  } = basketOperations;

  let { basketPax } = payload;

  try {
    if (!payload.hasBasket) {
      const createBasketResponse = yield call(createBasket, payload.bookingRef);

      if (createBasketResponse.errors) {
        // Handle web service errors.
        yield all(
          createBasketResponse.errors.map(error => put(createError(error))),
        );
        return;
      }

      yield put(
        createBasketSuccess(
          createBasketResponse.bookingRef,
          createBasketResponse.basket,
        ),
      );
      basketPax = createBasketResponse.basket.pax || [];
    }

    // find correct pax_id for logged in customer and set
    const pax_id =
      basketPax?.find(({ customer_id }) => customer_id === payload.customerId)
        ?.id || 1;
    payload.extras = payload.extras.map(extra => ({ ...extra, pax_id }));

    const addToBasketResponse = yield call(
      addExtraToBasket,
      payload.bookingRef,
      payload.extras,
    );

    if (addToBasketResponse.errors) {
      // Handle web service errors.
      yield all(
        addToBasketResponse.errors.map(error => put(createError(error))),
      );

      yield put(addToBasketFailed());
      if (!payload.hasBasket) {
        yield put(resetBasket(payload.bookingRef));
      }
      return;
    }

    const basketResponse = yield call(reloadBasket, payload.bookingRef);
    if (basketResponse.errors) {
      return;
    }

    const { extras } = payload;

    yield put(
      sendMessage({
        type: 'success',
        displayType: 'toast',
        message: `${extras.length} x ${extras[0].name} ${
          extras.length > 1 ? 'were' : 'was'
        } added to your basket.`,
      }),
    );
  } catch (error) {
    yield put(
      createError({
        code: DAS_ADD_EXTRAS_TO_BASKET_FAILED,
      }),
    );
    yield put(addToBasketFailed());
    if (!payload.hasBasket) {
      yield put(resetBasket(payload.bookingRef));
    }
  }
};

export default takeLatest(ADD_EXTRAS_TO_BASKET, performAddExtrasToBasket);
